import React from 'react';

import { FooterLinkDto } from 'lib_api/lib/api/gen';

import TableWithoutPaginationAndSort from 'components/WrappedComponents/Table/TableWithoutPaginationAndSort';
import { ColumnProps } from 'components/WrappedComponents/Table/types';

import { useReferentielDashboardUnpagedSearch } from '../utils';

import DashboardHeader from './DashboardHeader/DashboardHeader';
import { mapToReadableProfile } from './utils/mappers';
import { useSearchFooterLink } from './utils/useSearch';
import CellDetailsAndActions from './CellDetailsAndActions';
import {
  FilterDashboardFooterLink,
  LINK_LABEL,
  PROFILE_LABEL,
  TEXT_LABEL,
} from './types';

function buildColumns(
  refreshDashboard: () => void,
): ColumnProps<FooterLinkDto>[] {
  return [
    {
      title: LINK_LABEL,
      buildCellContent: footerLink => footerLink.link,
    },
    {
      title: TEXT_LABEL,
      buildCellContent: footerLink => footerLink.text,
    },
    {
      title: PROFILE_LABEL,
      buildCellContent: footerLink => mapToReadableProfile(footerLink.profile),
    },
    {
      title: '',
      buildCellContent: footerLink => (
        <CellDetailsAndActions
          footerLink={footerLink}
          refreshDashboard={refreshDashboard}
        />
      ),
    },
  ];
}

function DashboardFooterLink(): React.ReactElement {
  const defaultFilter: FilterDashboardFooterLink = { valid: true };
  const { fetchData, filter, setFilter, refreshDashboard } =
    useReferentielDashboardUnpagedSearch(useSearchFooterLink, defaultFilter);

  return (
    <div className="table-container">
      <TableWithoutPaginationAndSort
        columns={buildColumns(refreshDashboard)}
        fetchData={fetchData}
        header={fetchedData => (
          <DashboardHeader
            totalCount={fetchedData?.total || 0}
            refreshDashboard={refreshDashboard}
            setFilter={setFilter}
            filter={filter}
          />
        )}
        buildItemKey={footerLink => footerLink.id}
        filter={filter}
        setFilter={setFilter}
      />
    </div>
  );
}

export default DashboardFooterLink;
